require('./cardsControlButton.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
// @ actions
const { switchCardControlOn, switchCardControlOff, resetCardControl } = require('actions/cardControl');
// @ commons
const OKModal = require('components/commons/OKModal/OKModal');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const Toggle = require('components/commons/toggle/toggle');
// @ utilities
const { FormattedText, formatText } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
//@constants
const { CARD_SIZE_MEDIUM } = require('constants/index');

class CardsControlButton extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            modalOpen: false
        }

        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.buildModalContent = this.buildModalContent.bind(this);
        this.handleClickOff = this.handleClickOff.bind(this);
        this.handleClickOn = this.handleClickOn.bind(this);
    }

    buildModalContent() {
        const { immCard, immCardControl } = this.props;
        const cardOn = immCard.get('control');
        const isInfirstStep = !immCardControl.get('success') && !immCardControl.get('error') && !immCardControl.get('inProgress');
        const onCloseCallback = immCardControl.get('inProgress') ? null : this.handleToggleModal;
        let content, titleLabel, submitLabel;
        let primaryButtonText;
        let primaryButtonDisabled = false;
        let primaryButtonCallback;
        let secondaryButtonText;
        let secondaryButtonCallback;
        let footerType;
        let title;

        if (isInfirstStep) {

            if (cardOn) {
                titleLabel = 'cardsControl-offTitle';
                submitLabel = 'cardsControl-offSubmit';
            } else {
                titleLabel = 'cardsControl-onTitle';
                submitLabel = 'cardsControl-onSubmit';
            }

            content = (
                <section className="cards-control-button__modal-content">
                    <CommercialAds path="cards" type="cards" immCard={immCard} size={CARD_SIZE_MEDIUM} />
                </section>
            );
            primaryButtonText = submitLabel;
            primaryButtonCallback = cardOn ? this.handleClickOff : this.handleClickOn;
            secondaryButtonText = 'common-cancel';
            secondaryButtonCallback = this.handleToggleModal;
            footerType = 'navigation';
            title = formatText(titleLabel, [
                immCard.getIn(['alias', 'current']),
                getLastNChars(immCard.get('number'), 4, '*')
            ]);
        } else if (immCardControl.get('inProgress')) {

            titleLabel = cardOn ? 'cardsControl-loadingOffTitle' : 'cardsControl-loadingOnTitle';

            content = (
                <section className="cards-control-button__modal-content">
                    <LoadingSection />
                </section>
            );
            primaryButtonDisabled = true;
            primaryButtonText = 'cardsControl-understand';
            footerType = 'navigation';
            title = formatText(titleLabel, [
                immCard.getIn(['alias', 'current']),
                getLastNChars(immCard.get('number'), 4, '*')
            ]);
        } else {
            let textLabel, warningElement, cardImageElement, titleInjectedStrings, bodyInjectedStrings;

            if (immCardControl.get('error')) {
                titleLabel = 'cardsControl-errorTitle';
                bodyInjectedStrings = [
                    immCard.getIn(['alias', 'current']),
                    getLastNChars(immCard.get('number'), 4, '*')
                ];
                textLabel = cardOn ? 'cardsControl-offErrorText' : 'cardsControl-onErrorText';
            } else {
                titleLabel = cardOn ? 'cardsControl-onTitleConfirmation' : 'cardsControl-offTitleConfirmation';
                textLabel = cardOn ? 'cardsControl-onText' : 'cardsControl-offText';
                titleInjectedStrings = [
                    immCard.getIn(['alias', 'current']),
                    getLastNChars(immCard.get('number'), 4, '*')
                ];

                cardImageElement = (
                    <section className="cards-control-button__modal-content">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size={CARD_SIZE_MEDIUM} />
                    </section>
                );

                if (!cardOn) {
                    warningElement = (
                        <div className="cards-control-button__modal-body-text cards-control-button__modal-body-text--highlighted">
                            <FormattedText
                                className="cards-control-button__modal-body-text--highlighted"
                                value="cardsControl-offTextWarn"
                            />
                        </div>
                    );
                }

                primaryButtonCallback = this.handleToggleModal;
                primaryButtonText = 'cardsControl-understand';
                footerType = 'navigation';
            }

            title = formatText(titleLabel, titleInjectedStrings);
            content = (
                <article>
                    <section className="cards-control-button__modal-body">
                        {cardImageElement}
                        <div className="cards-control-button__modal-body-text">
                            <FormattedText value={textLabel} injectedStrings={bodyInjectedStrings} />
                        </div>
                        {warningElement}
                    </section>
                </article>
            );
        }

        return (
            <OKModal
                content={content}
                footerType={footerType}
                isOpen={this.state.modalOpen}
                onCloseCallback={onCloseCallback}
                onPrimaryButtonClick={primaryButtonCallback}
                onSecondaryButtonClick={secondaryButtonCallback}
                primaryButtonDisabled={primaryButtonDisabled}
                primaryButtonText={primaryButtonText}
                secondaryButtonText={secondaryButtonText}
                shouldCloseOnOverlayClick={false}
                title={title}
            />
        );
    }

    handleClickOff() {
        const { immCard, switchCardControlOff } = this.props;

        return switchCardControlOff(immCard.get('cardId'));
    }

    handleClickOn() {
        const { immCard, switchCardControlOn } = this.props;

        return switchCardControlOn(immCard.get('cardId'));
    }

    handleToggleModal() {
        this.setState({
            modalOpen: !this.state.modalOpen
        }, () => {
            this.props.resetCardControl();
        });
    }

    render() {
        const { immCard, flagBasedFeatures, avoidCardControlButton, history } = this.props;
        const cardOn = immCard.get('control');
        const modalContent = this.buildModalContent();
        const tooltipText = cardOn ? 'cardsControl-offTooltip' : 'cardsControl-onSubmit';

        const toogle = (
            <div>
                <Toggle checked={cardOn} onClick={this.handleToggleModal} />
            </div>
        )

        const toggleWithTooltip = (this.state.modalOpen) ? toogle : (
            <OKTooltip
                content={tooltipText}
                offset={[0, -15]}
                target={toogle}
                type="descriptive"
            />
        )

        const toggleAndLabel = (
            <div className="cards-control-button__tooltip-container">
                <div className="cards-control-button__tooltip-container__tog">
                    {toggleWithTooltip}
                </div>
            </div>
        );

        const controlButtonContent = (
            <span className="cards-control-button">

                { toggleAndLabel }

                { modalContent }

                {
                    immCard.get('isConfigurable') &&
                    immCard.get('active') &&
                    immCard.get('isOperative') &&
                    flagBasedFeatures.get('card-control-enabled') &&
                    !avoidCardControlButton &&

                    // NOTE: this link could be refactored to OKLinkRestyled
                    <div className="link-preferences">
                        <button onClick={e => {e.stopPropagation(); history.push(`/myprofile/cards/config/${immCard.get('cardId')}`);}}>
                            {formatText('cardsConfig-buttonText')}
                        </button>
                    </div>
                }

            </span>
        );

        return controlButtonContent;
    }
}

CardsControlButton.propTypes = {
    history: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired,
    immCardControl: PropTypes.object.isRequired,
    flagBasedFeatures: PropTypes.object.isRequired,
    resetCardControl: PropTypes.func.isRequired,
    switchCardControlOff: PropTypes.func.isRequired,
    switchCardControlOn: PropTypes.func.isRequired,
    avoidCardControlButton: PropTypes.bool
}

module.exports = connect(state => ({
    flagBasedFeatures: state.flagBasedFeatures,
    immCardControl: state.cardControlOn,
}), {
    resetCardControl,
    switchCardControlOff,
    switchCardControlOn,
})(withRouter(CardsControlButton));
